module.exports = __webpack_public_path__ + "img/ipl-auction-thumb.5dc56c68.jpg";